/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 2/8/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {Button, Grid} from "@scuf/common";
import FaultCard from "../faults/list/FaultCard";

class FaultsListWithLink extends React.Component {

    getFaultCards(faults) {
        return faults.map(f => <Grid.Column key={f.id} width={4} sWidth={12}><FaultCard fault={f}/></Grid.Column>)
    }

    renderOnClickButton = () => {
        const {intl} = this.props
        const linkText = this.props.linkText ? this.props.linkText : intl.formatMessage({id: "card.more"})

        return this.props.onClick ?
            <Button type="link" onClick={this.props.onClick}>
                {linkText}
            </Button>
            :
            null
    }

    render() {
        const {title, faults} = this.props
        const faultsCards = this.getFaultCards(faults.slice(0, 3))

        return (
            <div className="faults-list-with-link">
                <h3>{title} ({faults.length})</h3>
                {faults.length > 0 ?
                    <React.Fragment>
                        <div className="content">
                            <Grid>{faultsCards}</Grid>
                        </div>
                        <div className="footer">
                            {this.renderOnClickButton()}
                        </div>
                    </React.Fragment>
                    :
                    null
                }
            </div>
        )
    }
}


export default injectIntl(FaultsListWithLink)